module.exports = __webpack_public_path__ + "img/Item9.5946f9bb.svg";